import { useCallback, useContext, useMemo } from "react";
import { matchPath, useResolvedPath } from "react-router";
import { useCustomNavigation } from "./useCustomNavigation";
import { useUser } from "./useUser";
import { SecureRoutesContext } from "components/Admin/Secure/SecureRoutes/SecureRoutes";

export const useRoute = (props: { path: string; strict?: boolean }) => {
  const context = useContext(SecureRoutesContext);

  const resolvedPath = useResolvedPath(props.path);

  const { userHasOneOfPermissions } = useUser();

  const { navigate } = useCustomNavigation();

  const isAvailable = useMemo(() => {
    const route = context.meta.find((route) => {
      if (props.strict) {
        const formattedPath = resolvedPath.pathname.replace(/^\/+/, "");

        const formattedRoute = route.path
          .replace(/^\/+/, "")
          .replace(/\?.*$/, "");

        return formattedPath === formattedRoute;
      }

      return matchPath(route.path, resolvedPath.pathname);
    });

    if (!route) {
      return false;
    }

    return userHasOneOfPermissions(route.permissions);
  }, [
    context.meta,
    props.strict,
    resolvedPath.pathname,
    userHasOneOfPermissions,
  ]);

  const customNavigate = useCallback(() => {
    navigate(props.path);
  }, [navigate, props.path]);

  return {
    isAvailable,
    navigate: customNavigate,
  };
};
